import React from 'react';
import Slider from 'react-slick'; // Import Slider from react-slick
import { useTranslation } from 'react-i18next';

const HeroSlider = () => {
  const {t} = useTranslation();
  // Slider settings for react-slick
  const settings = {
    // dots: true,
    // infinite: true,
    // speed: 3000,
    // slidesToShow: 2,
    // slidesToScroll: 2,
    // autoplay: true,
    // autoplaySpeed: 3000,
    // arrows: true,
    // fade: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  // Sample slide data (replace image URLs with your actual images)
  const slides = [
    // {
    //   image: "/assets/towner.jpg",
    //   text1: "Min & Ying Legal Services Professional Corporation Professional Corporation",
    //   text2: "BIROU DE AVOCAT SI INSOLVENTA",
    //   location: "Bucuresti",
    //   quote:
    //     '"Nu este o adevărată justiție acolo unde nu există dreptate, iar dreptatea nu poate fi găsită acolo unde nu există adevăr."',
    //   author: "Lucius Annaeus Seneca",
    // },
    {
      image: "/assets/safetrust.jpg",
      text1: "Min & Ying Legal Services Professional Corporation",
      text2: t('hero.p1Text2'),
      text3: t('hero.p1Text3'),
      // location: "Ontario Licensed Paralegal Notary Public Commissioner of Oath",
      // quote: '"Justice is the constant and perpetual will to allot to every man his due."',
      // author: "Domitus Ulpian",
    },
    {
      image: "/assets/safetrust2.png",
      // text1: "Min & Ying Legal Services Professional Corporation",
      // text2: "TRUSTED LEGAL ADVISORS",
      // location: "Bucuresti",
      quote: t('hero.p2Quote'),
      author: t('hero.p2Author'),
    },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="slider-container">
          <Slider {...settings}>
            {slides.map((slide, index) => (
              <div key={index}>
                <div
                  className="hero-section"
                  style={{ backgroundImage: `url(${slide.image})` }}
                >
                  <div className="hero-overlay"></div>
                  <div className="text-container d-flex flex-column justify-content-start align-items-start pt-6">
                    <div className="text-1 fw-bold pb-3 hero-title">{slide.text1}</div>
                    <div className="text-2 fs-4">
                      {slide.text2}
                      <br />
                      {slide.text3}
                    </div>
                    <div className="text-2 fs-4">
                      {/* {slide.text2} */}
                      <span className="fw-bold">
                        <br />
                        {slide.location}
                      </span>
                    </div>
                    { slide.quote &&
                      <div className="text-3 fst-italic fw-light" style={{width: "100%"}}>
                        {slide.quote} - <span>{slide.author}</span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;